import { html as t, ref as i } from "@microsoft/fast-element";
const l = (c) => {
  const e = t.partial(c.prefix);
  return t`
    <div class="control" part="control">
      <div class="feedback">
        <label>
          <slot></slot>
        </label>
        <div class="satisfaction-rating">
          <${e}-button
            aria-label="Give positive feedback"
            size="md"
            @click="${(a) => a.handleFeedbackPositiveClick()}"
            class="feedback-button"
            variant="ghost"
          >
            <${e}-icon
              ${i("_positiveIconElement")}
              class="feedback-icon"
              name="hand-thumb-up"
            />
          </${e}-button>
          <${e}-button
            aria-label="Give negative feedback"
            size="md"
            @click="${(a) => a.handleFeedbackNegativeClick()}"
            class="feedback-button"
            variant="ghost"
          >
            <${e}-icon
              ${i("_negativeIconElement")}
              class="feedback-icon"
              name="hand-thumb-down"
            />
          </${e}-button>
        </div>
      </div>
    </div>
  `;
};
export {
  l as feedbackTemplate
};
